import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';

interface Props {
  isOpen: boolean;
  onOpenChange: () => void;
  onSubmit: () => void;
  description?: string;
  title?: string;
  isSubmitDisabled?: boolean;
}

export const ConnectionModal = ({
  isOpen,
  onOpenChange,
  onSubmit,
  title,
  description,
  isSubmitDisabled,
}: Props) => {
  const { t } = useTranslation('@mint-lib/connections-ui');

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="s">
          {title && (
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
            </DialogHeader>
          )}
          <DialogContent>
            {description && (
              <DialogDescription>{description}</DialogDescription>
            )}
          </DialogContent>
          <DialogFooter className="gap-2">
            <Button
              onClick={onOpenChange}
              variant="text"
              size="large"
              data-dd-action-name="cancel remove connection"
            >
              {t('Cancel')}
            </Button>
            <Button
              onClick={onSubmit}
              size="large"
              color="warning"
              disabled={isSubmitDisabled}
              data-dd-action-name="confirm remove connection"
            >
              {t('Yes, remove')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};
